<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Projects
          </div>
          <div class="card-block">
            <ProjectCategoryFilter v-model="categoryFilter"></ProjectCategoryFilter>
          </div>
          <div class="card-block">
            <table class="table table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <th>Project</th>
                  <th>Contract budget</th>
                  <th>Budgeted cost</th>
                  <th>Budget profit</th>
                  <th>Actual labour</th>
                  <th>Actual materials</th>
                  <th>ETC</th>
                  <th>EAC</th>
                  <th>Expected profit</th>
                  <th>Profit Variance</th>
                  <th>PoC</th>
                </tr>
              </thead>
              <tbody>
                <ProjectFinancesRow v-if="showProject(project.id)" v-for="project in projects" :key="project.id"
                  :projectId="project.id">
                </ProjectFinancesRow>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--/.col-->
    </div>
    <!--/.row-->
  </div>
</template>
<style lang="scss" scoped>
th {
  padding: 0;
}

tbody>tr:hover {
  background-color: #c8d2d2;
}
</style>
<script>
import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';
import ProjectFinancesRow from './ProjectFinancesRow.vue';
import ProjectCategoryFilter from './ProjectCategoryFilter.vue';

export default {
  name: 'Projects',
  components: {
    ProjectFinancesRow,
    ProjectCategoryFilter,
  },
  data: function () {
    return {
      currentProject: {},
      editProjectModal: false,
      categoryFilter: {},
    };
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects', 'projectCategories']),
    ...mapGetters('ProjectMaterials', []),
  },
  methods: {
    ...mapActions('IncomingPayments', [
      'LOAD_INCOMING_PAYMENTS']),
    ...mapActions('ProjectFinances', [
      'LOAD_PROJECT_FINANCES']),
    ...mapActions('ProjectMaterials', [
      'LOAD_PROJECT_MATERIALS']),
    ...mapActions('Clients', [
      'GET_INVOICES_LIST']),
    setAllCategoriesActive() {
      for (const categoryId in this.projectCategories) {
        Vue.set(this.categoryFilter, categoryId, true);
      }
      Vue.set(this.categoryFilter, 'active', true);
      Vue.set(this.categoryFilter, null, true);
    },
    showProject(projectId) {
      if (this.projectId) {
        return this.projectId == projectId;
      }
      const active = this.projects[projectId].start_date && (!this.projects[projectId].end_date || new Date(this.projects[projectId].end_date) > new Date());
      return (!this.categoryFilter['active'] || active) && this.categoryFilter[this.projects[projectId].category_id];
    },
  },
  mounted() {
    this.LOAD_INCOMING_PAYMENTS();
    this.LOAD_PROJECT_FINANCES();
    this.LOAD_PROJECT_MATERIALS({ weekCount: this.weekCount, weekOffset: this.weekOffset });
    this.GET_INVOICES_LIST();
    this.setAllCategoriesActive();
  }
};
</script>
